import { Link2, MessageCircle } from "lucide-react";
import { ShaklLogo } from "../brand/ShaklLogo";

const footerLinks = [
  ["Tools", "https://shakl.cc/tools"],
  ["Custom Tools", "https://shakl.cc/custom-tools"],
  ["Free Tools", "https://shakl.cc/#free"],
  ["About", "https://shakl.cc/about"],
  ["Support", "https://shakl.cc/support"],
] as const;

const socialLinks = [
  {
    label: "Instagram",
    href: "https://instagram.com/do_shakl",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.4" cy="6.7" r="1" className="social-dot" />
      </svg>
    ),
  },
  { label: "WhatsApp", href: "https://api.whatsapp.com/send?phone=966569645968", icon: <MessageCircle /> },
  {
    label: "YouTube",
    href: "https://youtube.com/@do_shakl",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M21 8.2a3 3 0 0 0-2.1-2.1C17.1 5.6 12 5.6 12 5.6s-5.1 0-6.9.5A3 3 0 0 0 3 8.2 31 31 0 0 0 2.6 12c0 1.3.1 2.6.4 3.8a3 3 0 0 0 2.1 2.1c1.8.5 6.9.5 6.9.5s5.1 0 6.9-.5a3 3 0 0 0 2.1-2.1c.3-1.2.4-2.5.4-3.8s-.1-2.6-.4-3.8Z" />
        <path d="m10 15.2 5.2-3.2L10 8.8v6.4Z" className="social-play" />
      </svg>
    ),
  },
  { label: "Linktree", href: "https://linktr.ee/do_shakl", icon: <Link2 /> },
] as const;

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-brand-block">
        <a className="footer-brand" href="https://shakl.cc" aria-label="SHAKL home">
          <ShaklLogo />
        </a>
        <p className="footer-signature" aria-label="Designed with love for all creative minds">
          Designed with <span className="shakl-heart" aria-hidden="true">♥</span> for all creative minds
        </p>
      </div>

      <nav className="footer-nav" aria-label="SHAKL footer navigation">
        {footerLinks.map(([label, href]) => (
          <a key={label} href={href}>{label}</a>
        ))}
      </nav>

      <div className="social-links social-links--compact" aria-label="SHAKL social links">
        {socialLinks.map((item) => (
          <a key={item.label} href={item.href} target="_blank" rel="noreferrer" aria-label={item.label}>
            {item.icon}
          </a>
        ))}
      </div>
    </footer>
  );
}
